var map = {
	"./asos-world.svg": 9971,
	"./errorEmoji.svg": 8730,
	"./filter.svg": 7072,
	"./heart.svg": 9262,
	"./iconClose.svg": 9187,
	"./iconCloseVariant.svg": 8278,
	"./iconDownCaret.svg": 3282,
	"./iconLeftCaret.svg": 8143,
	"./iconRightCaret.svg": 3130,
	"./iconRightChevron.svg": 3222,
	"./leftArrow.svg": 5768,
	"./newTab.svg": 7325,
	"./notification.svg": 9335,
	"./pause.svg": 8208,
	"./play.svg": 1272,
	"./promo.svg": 6567,
	"./search.svg": 3938,
	"./snowflake.svg": 7314,
	"./sort.svg": 434,
	"./swipe.svg": 3796,
	"./tick.svg": 7441,
	"./tickVariant.svg": 1844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5375;